import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { ThemeService } from '../../services/theme.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Title } from '@angular/platform-browser';
import { UserRoles } from '../../services/user.config';
import * as LZString from 'lz-string';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  public token: string | null = '';
  public eventId: string | null = '';
  public loading = true;
  public error = false;
  public storeName: any;
  storeLogo = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private titleService: Title,
    private themeService: ThemeService
  ) {
    route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.eventId = params['eventId'];
      this.storeLogo =
        this.appService.getDecodedAccessToken()?.shopping_logo_url ??
        '../../../assets/img/gitly-logo.png';
      if (this.token) {
        localStorage.clear();
        this.token = this.decompressString(this.token);
        localStorage.setItem('token', this.token);
      }
      if(this.eventId){
        this.eventId = this.decompressString(this.eventId);
        localStorage.setItem('event_id', this.eventId);
      }
      if (
        this.token &&
        this.appService.getDecodedAccessToken()?.role === UserRoles.promoter.id
      ) {
        this.titleService.setTitle('Gmall - Scanner Promotor');
        this.router.navigate(['/event']);
      } else if (
        this.token &&
        this.appService.getDecodedAccessToken()?.role ===
          UserRoles.storeAdmin.id
      ) {
        this.titleService.setTitle('Gmall - Scanner Lojista');
        this.router.navigate(['/qrScan']);
      } else {
        this.loading = false;
        this.error = true;
      }
    });
  }
  ngOnInit(): void {
    // Aplica o tema se estiver disponível no localStorage
    this.themeService.applyThemeIfAvailable();
  }
  
  // Função para descomprimir a string
  decompressString(compressed: string): string {
    const res = LZString.decompressFromEncodedURIComponent(compressed);
    return res;
  }

}
